import { useEffect, useState } from 'react';
import { Table, Button, Space, Collapse, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import DashboardService from '../../utils/api/DashboardService';
import moment from 'moment';

export default function ClientListAnalytics({ dateRange, monthRange, year }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchClients = async () => {
    try {
      setLoading(true);

      let params = {};

      if (dateRange && dateRange.length === 2) {
        params.start_date = dateRange[0].format('YYYY-MM-DD');
        params.end_date = dateRange[1].format('YYYY-MM-DD');
      }
      else if (monthRange && monthRange.length === 2) {
        params.start_date = monthRange[0].clone().startOf('month').format('YYYY-MM-DD');
        params.end_date = monthRange[1].clone().endOf('month').format('YYYY-MM-DD');
      }
      else if (year && year !== new Date().getFullYear()) {
        params.year = year;
      }
      else {
        const today = moment();
        const firstDayOfMonth = today.clone().startOf('month');
        params.start_date = firstDayOfMonth.format('YYYY-MM-DD');
        params.end_date = today.format('YYYY-MM-DD');
      }

      const response = await DashboardService.getClientsSalesDetail(params);

      if (response.data.success) {
        const formatted = response.data.clients
          .sort((a, b) => b.total_sales - a.total_sales)
          .map((client, index) => ({
            key: index,
            id: index,
            numero: index + 1,
            client_bussiness: client.client_bussiness,
            client_name: client.client_name,
            sales_count: client.sales_count,
            total_sales_mxn: client.total_sales_mxn,
            total_sales_usd: client.total_sales_usd,
         
            sales: client.sales || []
          }));

        setData(formatted);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [dateRange, monthRange, year]);

  const salesColumns = [
    {
      title: 'Nro. Orden',
      dataIndex: 'order_id',
      key: 'order_id',
      width: '10%'
    },
    {
      title: 'Servicio',
      dataIndex: 'title',
      key: 'title',
      width: '35%'
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      width: '25%'
    },

    {
      title: 'Precio de Venta',
      dataIndex: 'price',
      key: 'price',
      width: '15%',
      render: (price) => `$${price.toLocaleString('es-CO')}`
    }, {
      title: 'Tipo de Cambio',
      dataIndex: 'change_type',
      key: 'change_type',
      width: '15%',

    },

    {
      title: 'Estado de la orden',
      dataIndex: 'status',
      key: 'status',
      width: '10%',
      render: (status) => {
        const statusMap = {
          1: { label: 'En revisión', color: 'orange' },
          2: { label: 'En cotización', color: 'cyan' },
          3: { label: 'Pendiente de aprobación', color: 'gold' },
          4: { label: 'En construcción', color: 'blue' },
          5: { label: 'Inspección', color: 'purple' },
          6: { label: 'En camino', color: 'magenta' },
          7: { label: 'Entregado', color: 'green' },
          8: { label: 'Rechazado', color: 'red' },
          9: { label: 'Cancelado', color: 'volcano' },
          10: { label: 'En corrección', color: 'orange' },
          11: { label: 'Cancelacion solicitada', color: 'red' },
          12: { label: 'En queja', color: 'orange' }
        };
        const st = statusMap[status] || { label: 'Desconocido', color: 'default' };
        return <Tag color={st.color}>{st.label}</Tag>;
      }
    }
  ];

  const columns = [
    {
      title: 'Nro. Clientes',
      dataIndex: 'numero',
      key: 'numero',
      width: 60,
      align: 'center'
    },
    {
      title: 'Cliente',
      dataIndex: 'client_bussiness',
      key: 'client_bussiness',
      width: '35%'
    },
    {
      title: 'Contacto',
      dataIndex: 'client_name',
      key: 'client_name',
      width: '20%'
    },
    {
      title: 'No. de Ventas',
      dataIndex: 'sales_count',
      key: 'sales_count',
      width: '15%',
      align: 'center'
    },
    {
      title: 'Total de Ventas en MXN',
      dataIndex: 'total_sales_mxn',
      key: 'total_sales_mxn',
      width: '15%',
      render: (total_sales_mxn) => <span style={{ fontWeight: 'bold', color: '#0f5197' }}>${total_sales_mxn}</span>
    },
    {
      title: 'Total de Ventas en USD',
      dataIndex: 'total_sales_usd',
      key: 'total_sales_usd',
      width: '15%',
      render: (total_sales_usd) => <span style={{ fontWeight: 'bold', color: '#0f5197' }}>${total_sales_usd}</span>
    }
  ];

  return (
    <div>


      <Table
        className="clients-table"
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10, align: "center", showSizeChanger: true, pageSizeOptions: ['10', '20', '50'] }}
        scroll={{ x: true }}
        style={{ width: '100%' }}
        expandable={{
          expandedRowRender: (record) => (
            <div className="expanded-sales-detail">
              <Table
                className="sales-detail-table"
                columns={salesColumns}
                dataSource={record.sales}
                rowKey={(row, index) => index}
                pagination={false}
                size="small"
                scroll={{ x: true }}
                bordered
              />
            </div>
          ),
          expandRowByClick: true
        }}
      />
    </div>
  );
}
